import EditorImage from './core/editor-image';

export enum ImageEditEvents {
    WillCreateImages = 'will-create-images',
    DidCreateImages = 'did-create-images',
    CreateImageError = 'create-image-error',

    // Upload Events
    UploadError = 'upload-error',
    DidUpload = 'did-upload',
    UploadGifError = 'upload-gif-error',
    DidUploadGif = 'did-upload-gif',

    // Validate Events
    ValidateError = 'validate-error',
    DidValidate = 'did-validate',
}

export interface ImageEditEventHandlers {
    [ImageEditEvents.WillCreateImages]: (blobs: Blob[]) => void;
    [ImageEditEvents.DidCreateImages]: (images: EditorImage[]) => void;
    [ImageEditEvents.CreateImageError]: (errs: Error[]) => void;
    [ImageEditEvents.UploadError]: (err: Error) => void;
    [ImageEditEvents.DidUpload]: () => void;
    [ImageEditEvents.UploadGifError]: (err: Error) => void;
    [ImageEditEvents.DidUploadGif]: () => void;
    [ImageEditEvents.ValidateError]: (err: Error) => void;
    [ImageEditEvents.DidValidate]: () => void;
}
